export function messageRebond():void {
  const $button = document.querySelectorAll(".message-rebond .close");

  for (let i = 0; i < $button.length; i++) {
    $button[i].addEventListener("click", function (event) {
      event.preventDefault;

      const $container = this.closest("div.message-rebond");
      $container.classList.add("hide");

      setTimeout(function () {
        $container.style.display = "none";
      }, 500);
    });
  }
}

